export function enableMouseDragScroll(element) {
    let isDown = false;
    let startX;
    let scrollLeft;
  
    element.addEventListener('mousedown', (e) => {
      isDown = true;
      element.classList.add('dragging');
      startX = e.pageX - element.offsetLeft;
      scrollLeft = element.scrollLeft;
    });
  
    element.addEventListener('mouseleave', () => {
      isDown = false;
      element.classList.remove('dragging');
    });
  
    element.addEventListener('mouseup', () => {
      isDown = false;
      element.classList.remove('dragging');
    });
  
    element.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - element.offsetLeft;
      const walk = (x - startX) * 1.5; // スクロール速度調整
      element.scrollLeft = scrollLeft - walk;
    });
  }